import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';
import { AuthGuard } from './guards/auth.guard';
import { AutoLoginGuard } from './guards/autologin.guard';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./pages/unsecure/unsecure.module').then(m => m.UnsecurePageModule)
    },
    {
        path: 'secure',
        loadChildren: () => import('./pages/secure/secure.module').then(m => m.SecurePageModule),
        canLoad: [AuthGuard]
    }
];
@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
